<template>
  <div :class="[`bg-${$route.meta.background}`]">
    <Preloader v-if="isLoading" />
    <eggos
      v-if="$route.meta.eggos !== undefined"
      :color="$route.meta.eggos"
    ></eggos>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Preloader from '@/components/Preloader.vue';
import Eggos from '../components/Eggos.vue';

export default {
  name: 'AuthLayout',

  components: {
    Eggos,
    Preloader,
  },

  computed: {
    ...mapState('layout', [
      'isLoading',
    ]),
  },
};
</script>
